import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'

import { getAccountStatusHelpLink } from 'models/General/selectors'

import { infoGreyIcon } from 'resources/images'

import { ACCOUNT_STATUS } from './constants'
import { Container, Tag, Icon, Description, InfoButton, InfoIcon } from './styles'

const AccountStatusPill = ({ status }) => {
  const accountStatusHelpLink = useSelector(getAccountStatusHelpLink)

  const { color, tintColor, icon, description } = ACCOUNT_STATUS[status] || ACCOUNT_STATUS.basic

  return (
    <Container>
      <Tag color={color}>
        <Icon src={icon} resizeMode="contain" />
        <Description color={tintColor}>{description}</Description>
        {!!accountStatusHelpLink && (
          <InfoButton href={accountStatusHelpLink} target="_blank" rel="noopener noreferrer">
            <InfoIcon src={infoGreyIcon} color={tintColor} />
          </InfoButton>
        )}
      </Tag>
    </Container>
  )
}

AccountStatusPill.propTypes = {
  status: PropTypes.oneOf(['basic', 'trusted', 'vip']).isRequired,
}

export default AccountStatusPill
